/** 从 issueSummary 尾部「（优先级 … 期望解决 …）」拆出字段并净化描述 */
export function splitEmbeddedIssueSummaryMeta(
  issueSummary: string,
  priority: string,
  expectedResolveBy: string,
): { issueSummary: string; priority: string; expectedResolveBy: string } {
  let s = String(issueSummary ?? '').trim();
  let pr = String(priority ?? 'P1').trim().toUpperCase();
  let er = String(expectedResolveBy ?? '').trim();

  const m1 = s.match(
    /\s*[（(]\s*优先级\s*[:：]?\s*(P[0-2])\s*[;；,，]\s*期望解决\s*[:：]?\s*(\d{4}-\d{2}-\d{2})\s*[）)]\s*$/i,
  );
  if (m1) {
    const head = s.slice(0, m1.index).trim();
    if (head) s = head;
    pr = m1[1].toUpperCase();
    if (!er) er = m1[2];
    return { issueSummary: s, priority: pr, expectedResolveBy: er };
  }

  if (!er) {
    const m2 = s.match(/\s*[（(][^（）)]*期望解决[^（）)]*(\d{4}-\d{2}-\d{2})[^（）)]*[）)]\s*$/);
    if (m2) {
      const head = s.slice(0, m2.index).trim();
      if (head) s = head;
      er = m2[1];
    }
  }

  return { issueSummary: s, priority: pr, expectedResolveBy: er };
}

/** 从任意文本中取首个 http(s) 链接（用于参考材料 snippet 等） */
export function extractFirstHttpUrl(text: string): string {
  const m = String(text ?? '').match(/https?:\/\/[^\s"'<>)\]}，。；、]+/i);
  return m ? m[0].replace(/[),.;，。；]+$/g, '') : '';
}
